import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { PATH } from '../../../../constants/path';
import { CONTEXT_ROOT, PAYMENT_THRESHOLD } from '../../../../constants';

import { fetchAccountGains } from '../../../../services/account/gains/actions';
import { fetchPaymentRequestOnGoingIfNeeded } from '../../../../services/account/paymentrequest/ongoing/actions';

import { getWaitingAmount } from '../../../../services/account/gains/selector';
import { getValidatedAmount } from '../../../../services/account/gains/selector';

import HeadComponent from '../../../HeadComponent';
import PaymentAreaComponent from './PaymentAreaComponent';
import ResumeCashbackComponent from './ResumeCashbackComponent';
import CashbackHistoryComponent from './CashbackHistoryComponent';
import LocalizedBreadcrumbItem from '../../../breadcrumb/LocalizedBreadcrumbsItem';

import './AccountPurchase.scss';

export class AccountPurchasePage extends React.Component {
    componentDidMount() {
        this.props.fetchPaymentRequestOnGoingIfNeeded();
    }

    render() {
        const { validatedAmount, waitingAmount, i18nPage } = this.props;

        return (
            <main id="p-compte-cagnottecashback">
                <HeadComponent
                    title={i18nPage.TITLE}
                    description={i18nPage.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.ACCOUNT_JACKPOT_PATH}`}
                />
                <LocalizedBreadcrumbItem to={PATH.ACCOUNT_JACKPOT_PATH}>
                    {i18nPage.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <ResumeCashbackComponent
                    totalCashback={validatedAmount + waitingAmount}
                    cssClassLeft="valid"
                    leftAmount={validatedAmount}
                    cssClassRight="pending"
                    rightAmount={waitingAmount}
                />
                <PaymentAreaComponent thresholdReached={validatedAmount >= PAYMENT_THRESHOLD} />
                <CashbackHistoryComponent />
            </main>
        );
    }
}

AccountPurchasePage.propTypes = {
    validatedAmount: PropTypes.number,
    waitingAmount: PropTypes.number,
    i18nPage: PropTypes.object.isRequired,
    fetchAccountGains: PropTypes.func.isRequired,
    fetchPaymentRequestOnGoingIfNeeded: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        validatedAmount: getValidatedAmount(state),
        waitingAmount: getWaitingAmount(state),
        i18nPage: state.i18n.page.ACCOUNT.CASHBACK
    };
}

const mapDispatchToProps = {
    fetchAccountGains,
    fetchPaymentRequestOnGoingIfNeeded
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountPurchasePage);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/AccountPurchasePage.js